import { render, staticRenderFns } from "./electronicSheet.vue?vue&type=template&id=d870627a&scoped=true"
import script from "./electronicSheet.vue?vue&type=script&lang=js"
export * from "./electronicSheet.vue?vue&type=script&lang=js"
import style0 from "./electronicSheet.vue?vue&type=style&index=0&id=d870627a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d870627a",
  null
  
)

export default component.exports